import { render, staticRenderFns } from "./UnsubscribeFromEmail.vue?vue&type=template&id=52c7a7e6&"
import script from "./UnsubscribeFromEmail.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeFromEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports